import { useEffect } from "react";

/** Before printing: open every closed accordion under `rootId` and name the
 *  PDF after the page; afterwards put both back. Tabs are expanded by the
 *  print stylesheet (CSS can't open a <details>, hence the JS). */
export function useKbPrintPrep(title, rootId = "kb-article-body") {
  useEffect(() => {
    let opened = [];
    let savedTitle = "";
    const before = () => {
      const root = document.getElementById(rootId);
      opened = root ? [...root.querySelectorAll("details:not([open])")] : [];
      opened.forEach((d) => { d.open = true; });
      savedTitle = document.title;
      if (title) document.title = `${title} — Knowledge Base`;
    };
    const after = () => {
      opened.forEach((d) => { d.open = false; });
      opened = [];
      if (savedTitle) document.title = savedTitle;
    };
    window.addEventListener("beforeprint", before);
    window.addEventListener("afterprint", after);
    return () => {
      window.removeEventListener("beforeprint", before);
      window.removeEventListener("afterprint", after);
    };
  }, [title, rootId]);
}
